{
  "plovila": {
    "main": {
      "title": "Camo pregledi - Plovila"
    },
    "buttons": {
      "nazaj": "Nazaj",
      "nazajGlavni": "Glavni meni"
    },
    "table": {
      "registracija": "Registracija",
      "tip": "Tip",
      "vrsta": "Vrsta",
      "podrobno": "Podrobnosti",
      "s_ure": "Skupaj ur",
      "s_letov": "Skupaj letov"
    },
    "modal": {
      "vlecno": "Vlečno letalo:",
      "obracun_servis": "Beleženje 'Flight':",
      "razpolozljivo": "Vidno v razpoložljivosti:",
      "tip": "Tip:",
      "klub": "Klub:",
      "stUr": "Število začetnih ur:",
      "stLetov": "Število začetnih letov:",
      "stSUr": "Ure letenja:",
      "vrsta": "Vrsta letala:",
      "datumN": "Datum nakupa:",
      "datumR": "Datum registracije:",
      "opombaJ": "Opomba jadralno:",
      "datumV": "Datum vnosa:",
      "servis": {
        "stSUr": "Stanje ur:",
        "stLetov": "Stanje letov:",
        "interval": "Servisni interval: ",
        "datum_zServis": "Datum zadnjega servisa: ",
        "opravljen_servis": "Servis opravljen pri:",
        "naslednji_servis": "Naslednji servis: ",
        "status": "Status: "
      }
    },
    "navs": {
      "vnos": "Vnos",
      "seznam": "Seznam",
      "modal": {
        "pregled": "Pregled",
        "servisna": "Servisna knjiga"
      }
    }
  }
}